var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEye = function SvgIconEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_eye_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_eye_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M10 13.5c.972 0 1.799-.34 2.48-1.02.68-.681 1.02-1.508 1.02-2.48s-.34-1.799-1.02-2.48C11.798 6.84 10.971 6.5 10 6.5s-1.799.34-2.48 1.02C6.84 8.202 6.5 9.029 6.5 10s.34 1.799 1.02 2.48c.681.68 1.508 1.02 2.48 1.02Zm0-1.5a1.929 1.929 0 0 1-1.417-.583A1.929 1.929 0 0 1 8 10c0-.556.194-1.028.583-1.417A1.929 1.929 0 0 1 10 8c.556 0 1.028.194 1.417.583.389.39.583.861.583 1.417s-.194 1.028-.583 1.417A1.929 1.929 0 0 1 10 12Zm0 4a9.078 9.078 0 0 1-4.98-1.448 10.636 10.636 0 0 1-3.603-3.823 1.13 1.13 0 0 1-.146-.35 1.682 1.682 0 0 1 0-.754c.028-.125.076-.243.146-.354A10.636 10.636 0 0 1 5.02 5.448 9.078 9.078 0 0 1 10 4c1.806 0 3.465.483 4.98 1.448a10.636 10.636 0 0 1 3.603 3.823c.07.11.118.227.146.35a1.68 1.68 0 0 1 0 .754 1.126 1.126 0 0 1-.146.354 10.637 10.637 0 0 1-3.604 3.823A9.078 9.078 0 0 1 10 16Zm0-1.5a8.123 8.123 0 0 0 4.313-1.208A8.085 8.085 0 0 0 17.354 10a8.084 8.084 0 0 0-3.041-3.292A8.122 8.122 0 0 0 10 5.5a8.123 8.123 0 0 0-4.312 1.208A8.085 8.085 0 0 0 2.646 10a8.085 8.085 0 0 0 3.042 3.292A8.123 8.123 0 0 0 10 14.5Z"
  }))));
};
export default SvgIconEye;